import { useToastMessagesStore } from "@/Stores/ToastMessagesStore";

export const useAddToast = () => useToastMessagesStore((state) => state.addToastMessage);
